import { LS_ACCESS_TOKEN_KEY } from "../constants/GlobalConstants";
import i18n from "../i18n";

export const getHeaders = () => {
	const lsToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);

	if (lsToken) {
		return {
			Authorization: lsToken,
		};
	} else return {};
};

export const validatePassword = (pwd) => {
	var regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,100}$/;
	var valid = regex.test(pwd);
	return valid;
};

export const validateEmail = (email) => {
	const re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export const capitalize = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getDeclarationLabel = (declaration, index) => {
	return `${i18n.t(`common:${declaration.jdeclaration.data.declaration.service}`)} #${index + 1}`;
};
